export default "<nb-menu [items]=\"sidebarService.menuItems\">\n</nb-menu>\n    "